// api.js

import axios from 'axios';

// 创建一个 Axios 实例
const apiClient = axios.create({
  baseURL: 'https://admin-api.dfzt.top', // 线上
  // baseURL: 'https://test-api.dfzt.top/admin-api', // 测试
});

// 封装 GET 请求方法
export const get = (url, params) => {
  return apiClient.get(url, { params });
};

// 封装 POST 请求方法
export const post = (url, data) => {
  return apiClient.post(url, data);
};

// 其他封装的请求方法...

export default apiClient;
